import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import VerificationTestFormulaListComponent from './VerificationTestFormulaListComponent';
import { Card, FakeText, Autocomplete, TextField, Button } from '@totalsoft/rocket-ui';
import { FilterFrames } from '@mui/icons-material';
import { Typography, Grid, Tooltip } from '@mui/material';
import { emptyArray } from 'utils/constants';

import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const VerificationTypeTestComponent = ({
  verificationTestResponse,
  documentTypes,
  onVerificationClickTest,
  documentNumber,
  documentTypeId,
  onPropertyChange,
  verificationTypeId,
  validation,
  verificationType
}) => {
  const { t } = useTranslation();

  return (
    <Card
      icon={FilterFrames}
      iconColor='primary'
      title={
        <Grid container spacing={1}>
          <Grid item>
            <Typography noWrap fontSize='large'>
              {t('VerificationTypes.TestingApplicabilityFormula.Title')} {verificationType.verificationName}{' '}
              {t('VerificationTypes.TestingApplicabilityFormula.ForApplyFormula')}
            </Typography>
          </Grid>
          <Grid item>
            <Typography noWrap fontSize='large' fontWeight={'bold'}>
              {verificationType.applyFormula}
            </Typography>
          </Grid>
        </Grid>
      }
    >
      <Grid container spacing={1}>
        <Grid item xs={4} sm={4}>
          <Autocomplete
            required
            fullWidth
            value={documentTypeId || ''}
            label={t('VerificationTypes.DocumentType')}
            options={documentTypes}
            onChange={value => onPropertyChange('documentTypeId', value)}
            simpleValue
            error={!isValid(validation.documentTypeId)}
            helperText={getErrors(validation.documentTypeId)}
          />
        </Grid>
        <Grid item xs={3} sm={4}>
          <Tooltip title={t('VerificationTypes.TestingApplicabilityFormula.DocumentId')}>
            <TextField
              required
              fullWidth
              value={documentNumber || ''}
              onChange={value => onPropertyChange('documentNumber', value)}
              label={t('VerificationTypes.TestingApplicabilityFormula.Identifier')}
              error={!isValid(validation.documentNumber)}
              helperText={getErrors(validation.documentNumber)}
            />
          </Tooltip>
        </Grid>
        <Grid item xs={3} sm={4} sx={{ marginTop: '15px' }}>
          <Button
            fontSize='medium'
            color={documentNumber && documentTypeId ? 'primary' : 'transparent'}
            variant={'outlined'}
            disabled={!documentNumber || !documentTypeId}
            tooltip={
              documentNumber && documentTypeId
                ? t('Tooltips.Test')
                : t('VerificationTypes.TestingApplicabilityFormula.Validations.InvalidEntityIdentifier')
            }
            onClick={() => documentNumber && documentTypeId && onVerificationClickTest(verificationTypeId)}
          >
            {t('Tooltips.Test')}
          </Button>
        </Grid>
        <Grid item xs={12} sx={{ marginTop: '40px' }}>
          {verificationTestResponse === emptyArray ? (
            <FakeText lines={10} />
          ) : (
            <Grid container spacing={1}>
              <VerificationTestFormulaListComponent verificationTestResponse={verificationTestResponse} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

VerificationTypeTestComponent.propTypes = {
  verificationTypeId: PropTypes.string.isRequired,
  verificationTestResponse: PropTypes.array,
  documentTypes: PropTypes.array.isRequired,
  onVerificationClickTest: PropTypes.func.isRequired,
  documentNumber: PropTypes.string.isRequired,
  documentTypeId: PropTypes.array.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  validation: PropTypes.object,
  verificationType: PropTypes.object.isRequired
};

export default VerificationTypeTestComponent;
